import React from 'react';
import { FaPlus, FaEdit, FaTrash } from 'react-icons/fa';
import Pagination from '../../components/Pagination';

const ConstrutoresTab = ({
  construtores,
  pesquisaConstrutores,
  setPesquisaConstrutores,
  loadingTable,
  filtrarConstrutores,
  getTelefoneConstrutor,
  formatCPFCNPJConstrutor,
  handleEditConstrutor,
  handleDeleteConstrutor,
  setShowConstrutorModal,
  getConstrutoresPaginados,
  pageConstrutores,
  setPageConstrutores,
  itemsPerPageConstrutores,
  setItemsPerPageConstrutores
}) => {
  const construtoresFiltrados = filtrarConstrutores(construtores);
  const construtoresPaginados = getConstrutoresPaginados(construtoresFiltrados);

  // Resetar página quando pesquisa mudar
  React.useEffect(() => {
    setPageConstrutores(1);
  }, [pesquisaConstrutores, setPageConstrutores]);
  return (
    <div className="dashboard-section">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
        <h2>Gerenciar Construtores</h2>
        <button className="btn-add" onClick={() => setShowConstrutorModal(true)}>
          <FaPlus /> Adicionar Construtor
        </button>
      </div>
      
      {/* Campo de pesquisa */}
      <div style={{ marginBottom: '1rem' }}>
        <input
          type="text"
          placeholder="Pesquisar construtores (nome, CPF/CNPJ, telefone, email...)"
          value={pesquisaConstrutores}
          onChange={(e) => setPesquisaConstrutores(e.target.value)}
          style={{
            width: '100%',
            padding: '0.75rem',
            border: '1px solid #ddd',
            borderRadius: '5px',
            fontSize: '0.9rem'
          }}
        />
      </div>
      
      {loadingTable ? (
        <div className="loading">Carregando construtores...</div>
      ) : (
        <div className="imoveis-table">
          <table>
            <thead>
              <tr>
                <th>Nome</th>
                <th>CPF/CNPJ</th>
                <th>Telefone</th>
                <th>Email Corporativo</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {construtoresFiltrados.length === 0 ? (
                <tr>
                  <td colSpan="5" className="no-data">
                    Nenhum construtor encontrado
                  </td>
                </tr>
              ) : (
                construtoresPaginados.map(construtor => (
                  <tr key={construtor.id}>
                    <td>{construtor.nome}</td>
                    <td>{formatCPFCNPJConstrutor(construtor)}</td>
                    <td>{getTelefoneConstrutor(construtor)}</td>
                    <td>{construtor.email_corporativo || '-'}</td>
                    <td>
                      <div className="actions">
                        <button
                          onClick={() => handleEditConstrutor(construtor)}
                          className="btn-action btn-edit"
                          title="Editar"
                        >
                          <FaEdit />
                        </button>
                        <button
                          onClick={() => handleDeleteConstrutor(construtor.id)}
                          className="btn-action btn-delete"
                          title="Excluir"
                        >
                          <FaTrash />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
          
          {construtoresFiltrados.length > 0 && (
            <Pagination
              currentPage={pageConstrutores}
              totalItems={construtoresFiltrados.length}
              itemsPerPage={itemsPerPageConstrutores}
              onPageChange={setPageConstrutores}
              onItemsPerPageChange={setItemsPerPageConstrutores}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default ConstrutoresTab;


